import { render, staticRenderFns } from "./chat-info.vue?vue&type=template&id=03cdcbba&scoped=true"
import script from "./chat-info.vue?vue&type=script&lang=js"
export * from "./chat-info.vue?vue&type=script&lang=js"
import style0 from "./chat-info.vue?vue&type=style&index=0&id=03cdcbba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cdcbba",
  null
  
)

export default component.exports